import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { resolveImage } from "@/lib/image";

export default function Hero() {
  const { settings } = useSettings();
  const s = settings || {};
  const logo = resolveImage(s.logo_url);
  return (
    <section className="relative overflow-hidden bg-primary text-primary-foreground" data-testid="hero">
      <div className="m20-hero-grain absolute inset-0 opacity-70 pointer-events-none" />


      <div className="m20-container relative py-8 sm:py-10 lg:py-14 flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
        <div className="flex-1 space-y-3 sm:space-y-4">
          <span className="inline-flex items-center gap-2 bg-white/10 text-[11px] font-semibold uppercase tracking-[0.2em] px-3 py-1 rounded-full border border-white/20">
            <span className="w-1.5 h-1.5 bg-secondary rounded-full" /> {s.store_name || "MEGA 20"} • {s.location_label||"São Silvano · Colatina/ES"}
          </span>
          <h1 className="font-display font-bold uppercase leading-[0.95] text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            {s.hero_title||"É de Tomar da Mão!"}
          </h1>
          <div className="inline-block">
            <div className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl text-primary bg-secondary px-4 py-2 rounded-lg">
              {s.tagline || "TUDO POR R$ 20"}
            </div>
          </div>
          <p className="text-base sm:text-lg max-w-xl text-primary-foreground/90">
            {s.description || "Sua loja de preço único em Colatina. Utilidades para a casa e novidades por R$ 20."}
          </p>
          <div className="flex flex-wrap gap-2.5 pt-1">
            <Link to="/produtos" data-testid="hero-cta-products"
              className="inline-flex items-center gap-2 bg-secondary text-secondary-foreground font-display font-bold uppercase tracking-wide text-sm sm:text-base px-5 py-3 rounded-md shadow-lg hover:brightness-95 active:scale-95 transition">
              Explorar catálogo <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        {logo ? (
          <div className="hidden lg:block w-64 bg-primary rounded-xl p-4 border border-white/20 shrink-0">
            <img src={logo} alt="Logo" className="w-full h-full object-contain" />
          </div>
        ) : (
          <div className="hidden lg:flex w-64 h-40 bg-secondary text-secondary-foreground rounded-xl shrink-0 flex-col items-center justify-center p-4 border border-white/20">
            <div className="text-xs font-semibold uppercase tracking-wider">Sua loja de preço único</div>
            <div className="font-display text-5xl font-bold leading-none">R$ 20</div>
            <div className="text-[10px] font-semibold uppercase mt-1 tracking-widest">Toda loja</div>
          </div>
        )}
      </div>
    </section>
  );
}
